"use strict";

var __importDefault = undefined && undefined.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var popover_1 = __importDefault(require("../../../node_modules/bootstrap-vue/es/components/popover/popover"));
vue_1.default.component("b-popover", popover_1.default);


//////////////////
// WEBPACK FOOTER
// ./_wwwsrc/js/SharedComponent/custom-bsvue.ts
// module id = 623
// module chunks = 0